<template>
<div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

  <div class="fixed inset-0 z-10 overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
        <form
          id="addEditForm"
          @submit.prevent="onSubmit"
          class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4"
        >
          <!-- <div class="sm:flex sm:items-start">
            <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Deactivate account</h3>
              <div class="mt-2">
                <p class="text-sm text-gray-500">Are you sure you want to deactivate your account? All of your data will be permanently removed. This action cannot be undone.</p>
              </div>
            </div>
          </div> -->

          <div class="space-y-6">

            <div>
              <label for="body" class="block text-sm font-medium text-gray-700">
                Testimonial
              </label>
              <textarea
                v-model.trim="formBody"
                name="body"
                id="body"
                rows="5"
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400"
              />
              <p v-if="$v.formBody.$dirty && !$v.formBody.required" class="mt-2 text-sm text-red-600">
                Please enter a testimonial.
              </p>
              <p v-if="$v.formBody.$dirty && !$v.formBody.maxLength" class="mt-2 text-sm text-red-600">
                Exceeds 500 character limit, please reduce the length of your testimonial.
              </p>
              <p class="mt-1 text-xs text-gray-500 leading-relaxed">
                Maxiumum 500 characters.
              </p>
            </div>

            
            
            <div>
              <label for="name" class="block text-sm font-medium text-gray-700">
                Authors First Name
              </label>
              <input
                v-model.trim="formName"
                name="name"
                id="name"
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400"
              />
              <p v-if="$v.formName.$dirty && !$v.formName.required" class="mt-2 text-sm text-red-600">
                Please enter a name.
              </p>
            </div>



            <div>
              <label for="location" class="block text-sm font-medium text-gray-700">
                Authors Location (approx.)
                <span class="ml-1 text-xs text-gray-400 font-normal italic">Optional</span>
              </label>
              <input
                v-model.trim="formLocation"
                name="location"
                id="location"
                placeholder="e.g. London"
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400"
              />
            </div>



            <div>
              <label for="relationship" class="block text-sm font-medium text-gray-700">
                Authors Relationship
                <span class="ml-1 text-xs text-gray-400 font-normal italic">Optional</span>
              </label>
              <select
                v-model.trim="formRelationship"
                name="relationship"
                id="relationship"
                class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm placeholder-gray-400"
              >
                <option v-for="item of relationships" :key="item.value" :value="item.value">
                  {{ item.label }}
                </option>
              </select>
            </div>

          </div>
          


        </form>
        <div class="bg-gray-50 px-4 py-3 space-x-3 space-x-reverse flex flex-row-reverse sm:px-6">
          <TailwindButton
            type="submit"
            theme="primary"
            form="addEditForm"
            :disabled="isSaving"
            :loading="isSaving"
            @click="onSave"
          >
            Save
          </TailwindButton>

          <TailwindButton
            theme="outline"
            @click="onCancel"
          >
            Cancel
          </TailwindButton>
          <!-- <button type="button" @click="onCancel" class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">Deactivate</button>
          <button type="button" @click="onSave" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import TailwindButton from '../TailwindButton.vue'

import TutorService from '@/services/TutorServices'
const tutorService = new TutorService()

export default {
  components: { 
    TailwindButton,
  },
  props: {
    testimonialId: String,
  },
  data() {
    return {
      relationships: [
        { label: '', value: null },
        { label: 'Student', value: 'STUDENT' },
        { label: 'Parent', value: 'PARENT' },
        { label: 'Other', value: 'OTHER' },
      ],
      formBody: '',
      formName: '',
      formLocation: '',
      formRelationship: '',
      isSaving: false,
    }
  },
  validations: {
    formBody: { required, maxLength: input => input.length <= 500 },
    formName: { required },
  },
  methods: {
    async onSave() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isSaving = true

      try {
        await tutorService.saveTestimonial({
          id: this.testimonialId,
          body: this.formBody,
          name: this.formName,
          location: this.formLocation,
          relationship: this.formRelationship,
        })

        await this.$store.dispatch('refreshUser')

        this.$emit('saved')
      }
      catch {
        alert('There was a problem saving your testimonial, please try again.')
      }
      finally {
        this.isSaving = false
      }
    },
    onCancel() {
      this.$emit('close')
    },
  },
  mounted() {
    if (this.testimonialId) {
      var testimonial = this.$store.getters.user.Testimonials.find(x => x.Id === this.testimonialId)
      this.formBody = testimonial.Body
      this.formName = testimonial.Name
      this.formLocation = testimonial.Location
      this.formRelationship = testimonial.Relationship
    }
  }
}
</script>

<style lang="scss" scoped>

</style>